export default __webpack_public_path__ + "static/media/CorrectCar.4774f079.svg";